import { render } from "./ChangeMobileForm.vue?vue&type=template&id=3c2136e2&scoped=true"
import script from "./ChangeMobileForm.vue?vue&type=script&lang=js"
export * from "./ChangeMobileForm.vue?vue&type=script&lang=js"

import "./ChangeMobileForm.vue?vue&type=style&index=0&id=3c2136e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2136e2"]])

export default __exports__